export const enum PlotsActionType {
  UpdateLoadState = 'plots/updateLoadState',
  UpdateState = 'plots/updateState',
  UpdateRemainingSupply = 'plots/updateRemainingSupply',
}
